import { get } from 'lodash';

export const getGrades = state => get(state, 'SalesAnalysisState.grades', []);

export const getSites = state => get(state, 'CommonState.sites.info.Data', []);

export const getUsers = state =>
  get(state, 'TransactionHistoryState.usersData');

export const getLoading = state => get(state, 'SalesAnalysisState.users');

export const getErrors = state => get(state, 'SalesAnalysisState.fetchError');



// WEBPACK FOOTER //
// ./src/pages/salesanalysis/state/selector.js